export default "__VITE_ASSET__N5vuib0v__"